export class Driver {
    constructor(
        public readonly id: number,
        public readonly name: string,
        public readonly registration: string
    ) {}

    get isIdentified(): boolean {
        return this.name !== 'Motorista não identificado';
    }

    static createUnidentified(registration: string = ''): Driver {
        return new Driver(0, 'Motorista não identificado', registration);
    }
}

